import React from "react";

import { FormControlLabel, FormControl, FormLabel, RadioGroup, Radio } from "@material-ui/core";

export const CommonRadioGroup = ({
  id,
  label,
  values,
  errors,
  touched,
  setFieldValue,
  disabled,
  className,
  options,
  ...props
}: any) => {
  //Options
  const isValidationFailed = errors && touched && errors[id] && touched[id];
  const errorExtension = (isValidationFailed ? "error" : "");
  const radioGroupClassName = className ? className + (errorExtension ? "--" + errorExtension : "") : errorExtension;

  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{label}</FormLabel>
      <RadioGroup 
        {...props}
        className={radioGroupClassName}
        name="limitIncreasedBy"
        value={values[id].toString()}
        onChange={(e: any) => setFieldValue(id, parseInt(e.target.value))}
      >
        {options.map((option: any) =>
          <FormControlLabel 
            key={option.value}
            value={option.value.toString()}
            control={<Radio />}
            label={option.label}
          />
        )}
      </RadioGroup>
    </FormControl>
  );
};
